import React from 'react'

import BannerMinKavli from '../../../react4xp/components/BannerMinKavli'

function MinKavlifavorittCardPart({ title, text, image, cta }) {
    return (
        <>
            {
                (title || text || image?.link || cta.text) &&
                <BannerMinKavli
                    section={{
                        bgColor: 'white'
                    }}
                    image={image?.link}
                    alt={image?.alt}
                    title={title}
                    desc={text}
                    cta={{
                        text: cta.text,
                        href: cta.url
                    }}
                />
            }
        </>
    )
}

export default (props) => <MinKavlifavorittCardPart {...props} />
